import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-settings-renderer',
    templateUrl: './settings-renderer.component.html',
    styleUrls: ['./settings-renderer.component.scss'],
    standalone: false // NOSONAR
})
export class SettingsRendererComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    console.info('something')
  }

}
